import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { FormHubspotComponent } from 'src/app/shared/components/form-hubspot/form-hubspot.component';
import { ModalGeneralComponent } from 'src/app/shared/components/modal-general/modal-general.component';
import { FormContactoComponent } from 'src/app/shared/widgets/form-contacto/form-contacto.component';

@Component({
  selector: 'app-aranceles-posgrado',
  templateUrl: './aranceles-posgrado.component.html',
  styleUrls: ['./aranceles-posgrado.component.scss']
})
export class ArancelesPosgradoComponent implements OnInit {

  @Input()
  datos: any;
  isDesktop = window.innerWidth > 767;



  scale = 1;
  translateX = 0;
  translateY = 0;
  isDragging = false;
  startX = 0;
  startY = 0;
  lastMouseX = 0;
  lastMouseY = 0;
  isModalOpen = false;

  venue = ""
  carrer = ""
  @ViewChild('imgContainer') imgContainer!: ElementRef;
  @ViewChild('containerDerecho') containerDer!: ElementRef;

  constructor(public dialog: MatDialog, private aRouter: ActivatedRoute
  ) {
    this.aRouter.params.forEach((params: Params) => {
      this.venue = this.aRouter.snapshot.params['seccion']
      this.carrer = this.aRouter.snapshot.params['id']
    });
  }


  expand() {
    this.isModalOpen = true;
  }

  close() {
    this.isModalOpen = false;
    this.scale = 1;
    this.translateX = 0;
    this.translateY = 0;
  }

  zoom(event: WheelEvent) {
    event.preventDefault();
    const zoomStep = 0.002;
    this.scale += event.deltaY * -zoomStep;
    this.scale = Math.max(0.3, Math.min(3, this.scale));
  }

  startDrag(event: MouseEvent) {
    event.preventDefault();
    this.isDragging = true;
    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }

  onDrag(event: MouseEvent) {
    if (!this.isDragging) return;
    const dx = event.clientX - this.lastMouseX;
    const dy = event.clientY - this.lastMouseY;

    this.translateX += dx;
    this.translateY += dy;

    this.lastMouseX = event.clientX;
    this.lastMouseY = event.clientY;
  }
  endDrag() {
    this.isDragging = false;
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.isModalOpen) {
      this.close();
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }
  ngOnInit(): void {
  }
  ngAfterContentInit() {
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isDesktop = (event.target as Window).innerWidth > 767;
    this.checkHeight();

  }




  openModalConsulta() {
    if (this.datos.form_hubspot) {
      this.dialog.open(FormHubspotComponent);
    } else {
      let dialogRef = this.dialog.open(FormContactoComponent, { panelClass: 'custom-dialog-container', data: { curso: null } });
      let instance = dialogRef.componentInstance;
      instance.venue = this.venue
      instance.carrer = this.carrer
      const sub = dialogRef.componentInstance.closeModal.subscribe(() => {
        this.dialog.closeAll();
      });
    }
  }
  openModal(item: any) {
    this.dialog.open(ModalGeneralComponent, { panelClass: 'custom-dialog-container', data: { html: item.body, title: item.title } });
  }
  openLink(item: any) {
    window.open(item.body, '_blank');
  }
  externalLink(link) {
    if (link) {
      window.open(link, '_blank');
    }
  }
  private bloqueo = 0;

  ngAfterViewChecked(): void {
    if (this.bloqueo < 2) {
      setTimeout(() => {
        // this.checkHeight();
      }, 0);
    }
  }
  checkHeight() {
    this.isDesktop = window.innerWidth > 768;

    if (this.containerDer != null && this.imgContainer != null) {

      if (this.isDesktop) {
        let alto = this.containerDer.nativeElement.offsetHeight;
        let altoAumentado = alto * 1.1;
        this.imgContainer.nativeElement.style.minHeight = `${(altoAumentado)}px`;
      } else {
        this.imgContainer.nativeElement.style.minHeight = `100%`;
      }
      this.bloqueo++;
    }


  }
}
